import { object, func } from 'prop-types'

import scope from 'recompose-scope/composeWithScope'
import consumeProps from 'recompose-scope/consumeProps'
import exposeProps from 'recompose-scope/exposeProps'

import withState from 'recompose/withState'
import getContext from 'recompose/getContext'
import withHandlers from 'recompose/withHandlers'
import lifecycle from 'recompose/lifecycle'
import pure from 'recompose/pure'

import objectEditorEnhancer from 'coact/objectEditorEnhancer'
import interceptUpdater from 'coact-utils/interceptUpdater'

import findPrice from './findPrice'

import ItemEditorView from './ItemEditor'

function doCountPrice (pdt1, pdt2) {
  if (pdt1 === pdt2) return false
  const { productKey, lensSpec: { s, c } = { } } = pdt1
  const { productKey: productKey2, lensSpec: { s: s2, c: c2 } = { } } = pdt2
  if (productKey !== productKey2) return true
  if (s !== s2 || c !== c2) return true
  return false
}

function computeSubtotal ({ unitPrice, qty }) {
  if (typeof unitPrice !== 'number') return undefined
  if (typeof qty !== 'number') return undefined

  return unitPrice * qty
}

const ItemEditor = scope(
  getContext({
    server: object.isRequired,
  }),
  consumeProps({
    value: object.isRequired,
    onChange: func.isRequired,
    schema: object.isRequired,

    copy: func.isRequired,
  }),

  pure,
  objectEditorEnhancer,


  interceptUpdater('onChange', () => value => {
    const { productRef } = value
    return {
      ...value,
      productKey: productRef && productRef.key,
      productName: productRef && productRef.name,
      productType: productRef && productRef.type,
      processType: productRef && productRef.processType,
      subtotal: computeSubtotal(value),
    }
  }),


  lifecycle({
    async componentDidUpdate (prevProps) {
      if (doCountPrice(prevProps.value, this.props.value)) {
        const { value, server } = this.props
        const unitPrice = await findPrice({ value, server })
        this.props.onChange(v => ({ ...v, unitPrice }))
      }
    },
  }),


  withState('full', 'toggleFullFeatures', false),
  withHandlers({
    toggleFullFeatures: ({ toggleFullFeatures }) => () =>
      toggleFullFeatures(fullFeatures => !fullFeatures),
  }),

  withHandlers({
    copy: ({ copy, value, server }) => async () => {
      const unitPrice = await findPrice({ value: { ...value, lensSpec: { s: 0, c: 0 } }, server })
      const copier = ({ productRef, productType, productKey, processType }) =>
        ({ productRef, productType, productKey, processType, unitPrice, subtotal: unitPrice })
      return copy({ copier })
    },
  }),

  exposeProps([
    'index',
    'value',
    'onChange',

    'schema',
    'spliter',

    'copy',
    'full',
    'toggleFullFeatures',

    'style',
  ])
)(ItemEditorView)

ItemEditor.displayName = 'ItemEditor'

export default ItemEditor



// WEBPACK FOOTER //
// ./src/components/SalesOrderEditor/ItemsEditor/ItemEditor/index.js